import { useEffect } from "react";
import { Link } from "react-router-dom";
import { site } from "@/data/store";

export default function NotFound() {
  useEffect(() => {
    document.title = `Page not found — ${site.brandName}`;
  }, []);

  return (
    <main data-testid="not-found-page" className="mx-auto flex min-h-[60vh] max-w-[1440px] flex-col items-start justify-center px-5 py-24 sm:px-8 lg:px-12">
      <p className="font-serif text-8xl font-light text-black/15">404</p>
      <h1 className="mt-4 font-serif text-5xl font-light sm:text-6xl">This page doesn't exist.</h1>
      <Link to="/" data-testid="go-home-link" className="mt-10 inline-flex h-12 items-center border border-black px-8 text-[13px] font-medium uppercase tracking-[0.14em] transition-colors duration-300 hover:bg-black hover:text-white">
        Go home
      </Link>
    </main>
  );
}
